import { navigate } from "../lib/router";

const FRONTEND_VERSION = import.meta.env.VITE_BUILD_VERSION || "dev";
const FRONTEND_HASH = import.meta.env.VITE_BUILD_HASH || "";

type Props = {
  backendVersion?: string;
};

export function Footer({ backendVersion }: Props) {
  return (
    <footer className="mx-auto max-w-6xl px-4 py-6 text-center text-xs text-ink-muted space-y-2">
      <div className="flex flex-wrap items-center justify-center gap-3">
        <span>DP Connect Agenten · {new Date().getFullYear()}</span>
        <a
          href="/agb"
          onClick={(e) => {
            e.preventDefault();
            navigate("/agb");
          }}
          className="hover:text-ink hover:underline"
        >
          AGB
        </a>
        <a
          href="/datenschutz"
          onClick={(e) => {
            e.preventDefault();
            navigate("/datenschutz");
          }}
          className="hover:text-ink hover:underline"
        >
          Datenschutz
        </a>
      </div>
      <div className="font-mono text-[11px]">
        Frontend {FRONTEND_VERSION}
        {FRONTEND_HASH && ` (${FRONTEND_HASH})`}
        {backendVersion && ` · Backend ${backendVersion}`}
      </div>
    </footer>
  );
}
